export default __webpack_public_path__ + "static/media/CoffeeHouseNoisesRain.274a81b2.wav";